import { useTranslation } from 'react-i18next';
import { formatDate, CATEGORY_ICONS } from '@/utils/format';
import { useCurrency } from '@/hooks/useCurrency';
import { Repeat } from 'lucide-react';

export default function TransactionItem({ transaction, compact = false }) {
  const { t } = useTranslation();
  const { format: formatCurrency } = useCurrency();
  const { description, amount, type, category, date, recurrence } = transaction;

  if (compact) {
    return (
      <div className="flex items-center gap-3">
        <span className="text-lg">{CATEGORY_ICONS[category]}</span>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-medium text-gray-900 dark:text-white truncate">
            {description}
          </div>
          <div className="text-xs text-gray-500 flex items-center gap-1">
            {formatDate(date)}
            {recurrence && recurrence !== 'none' && <Repeat size={10} className="text-brand-500" />}
          </div>
        </div>
        <span
          className={`text-sm font-semibold ${
            type === 'income' ? 'text-success-500' : 'text-gray-900 dark:text-white'
          }`}
        >
          {type === 'income' ? '+' : '-'}{formatCurrency(amount)}
        </span>
      </div>
    );
  }

  return (
    <div className="card flex items-center gap-3 p-4">
      <div className="w-10 h-10 rounded-xl bg-gray-100 dark:bg-gray-800 flex items-center justify-center text-lg">
        {CATEGORY_ICONS[category]}
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-gray-900 dark:text-white truncate">
          {description}
        </div>
        <div className="text-xs text-gray-500 flex items-center gap-1">
          {t(`categories.${category}`)} · {formatDate(date)}
          {recurrence && recurrence !== 'none' && <Repeat size={10} className="text-brand-500" />}
        </div>
      </div>
      <span
        className={`text-sm font-bold ${
          type === 'income' ? 'text-success-500' : 'text-danger-500'
        }`}
      >
        {type === 'income' ? '+' : '-'}{formatCurrency(amount)}
      </span>
    </div>
  );
}
